/* eslint-disable consistent-return */
import axios from 'axios';
import router from '@/router';
import { $i18n } from '@/provider/plugin';
import { authService } from '@/services/auth';
import filters from '@/filters/filters';
import { isEmpty } from '@/helper/lodashHelper';
import localStorageHelper from '@/helper/localStorageHelper';
import { getLocale } from '@/plugins/i18n';
import { $settings } from '@/provider/settings';
import { useRootStore } from '@/store/root';
import { useAuthStore } from '@/store/auth';

const parseErrorCodes = (error) => {
  const status = Number.parseInt(error.response.status, 10);
  const bodyStatus = Number.parseInt(error.response.data.statusCode, 10);

  return { status, bodyStatus };
};

const isUnauthorizedError = (error) => {
  const { status, bodyStatus } = parseErrorCodes(error);

  if (status === 401) return true;
  if (bodyStatus === 401) return true;
  return false;
};

// TODO: IW-3970 This is a Quick Fix. Remove me asap, when ticket is done!
const modifyKey = (key, type) =>
  (type === 'contact' && key.split('/')[0]) || key;

const getLink = (key, type) => {
  if (key && type) {
    return {
      type,
      key: modifyKey(key, type),
      text: $i18n.global.t('WX_GENERAL_LINK_OPEN'),
    };
  }

  return false;
};

axios.interceptors.request.use(async (request) => {
  if (
    (await authService.isAuthenticated()) &&
    request.url.includes($settings.middlewareURI)
  ) {
    const cid = useRootStore().getUserGroups.cid || localStorageHelper.getCid();
    return authService.getToken().then(({ accessToken }) => {
      request.withCredentials = true;
      request.headers.Authorization = `Bearer ${accessToken}`;
      request.headers['Access-Control-Allow-Origin'] = '*';
      // add SAP Information
      request.params = {
        ...request.params,
        'sap-language': getLocale(),
        'wx-cid': cid,
      };
      return request;
    });
  }
});

axios.interceptors.response.use(
  (response) => {
    const { OBJKEY, OBJTYPE, SUCCESS, MESSAGES = [] } = response.data;

    // Handle only response from Middleware
    if (
      response.config.url.includes($settings.middlewareURI) && // Handle error with response 200 but Error Text in Body
      // if (String(response.status) === '401' || String(response.data.statusCode) === '401') {
      //   if ($settings.useBasicAuth === true) {
      //     const redirect = router.history.current.path || '/';
      //     router.push({ path: `/${I18nInstance.locale}/basicAuth`, query: { redirect } });
      //   }
      // }

      // Handle error by SAP Response
      response.data &&
      isEmpty(MESSAGES) === false
    ) {
      const hasErrorWarningMessages = MESSAGES.some((message) =>
        ['W', 'E'].includes(message.TYPE),
      );
      MESSAGES.forEach((message) => {
        const { MESSAGE, TYPE } = message;

        if (['E'].includes(TYPE)) filters.showMessage('error', MESSAGE);

        if (['W'].includes(TYPE)) filters.showMessage('warn', MESSAGE);

        if (['S'].includes(TYPE))
          filters.showMessage('success', MESSAGE, getLink(OBJKEY, OBJTYPE));

        if (!hasErrorWarningMessages && ['I'].includes(TYPE))
          filters.showMessage('info', MESSAGE);
      });

      if (!SUCCESS) {
        const appLoading = document.querySelector('#loading-bg');
        if (appLoading) {
          appLoading.style.display = 'none';
        }
        console.warn(MESSAGES.filter(({ TYPE }) => TYPE === 'E'));
        console.warn(response);
        return Promise.reject(response);
      }
    }

    return response;
  },
  (error) => {
    if (
      !(
        error.response &&
        error.response.config.url.includes($settings.middlewareURI)
      )
    )
      return Promise.reject(error);

    if (isUnauthorizedError(error)) {
      if (!$settings.useBasicAuth) {
        useAuthStore().logout();
        return;
      }

      if (window.location.pathname.includes('basicAuth'))
        return Promise.reject(error);

      const redirect = router.history._startLocation || '/';
      const cid = localStorageHelper.getCid();
      router.push({
        path: `/${getLocale()}/${cid}/basicAuth`,
        query: { redirect },
      });
    }

    return Promise.reject(error);
  },
);

axios.defaults.withCredentials = true;

export { default } from 'axios';
